export default "__VITE_ASSET__CM0SB1BE__"